import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import { UpdatePerformanceRule, UpdatePerformanceRuleVariables } from './__generated__/UpdatePerformanceRule';

const UPDATE_PERFORMANCE_RULE_MUTATION = gql`
  mutation UpdatePerformanceRuleMutation($input: RulesInput!) {
    updatePerformanceRule(input: $input) {
      performanceRule {
        id
        name
        level
        evaluationSpec
        status
        createdBy
        triggered
        executionSpec
        campaign {
          id
        }
        triggeredAt
        articleIds
      }
      errors
    }
  }
`;

export const useUpdatePerformanceRuleMutation = () => {
  return useMutation<UpdatePerformanceRule, UpdatePerformanceRuleVariables>(UPDATE_PERFORMANCE_RULE_MUTATION, {
    client: kmsClient
  });
};
